import React from 'react';

import GenerationForm from './form/GenerationForm';
import RepliesForm from './reply-form/RepliesForm';

import scss from './GenerationSection.module.scss';

function GenerationSection() {
  return (
    <div className={scss.wrapper}>
      <GenerationForm />
      <div className={scss.delimiter}></div>
      <RepliesForm />
    </div>
  );
}

export default GenerationSection;
